import { parseTextToID } from "./parseTextToID";

export const scrollToSection = (id) => {
  const section = document.getElementById(parseTextToID(id));
  section.scrollIntoView({ behavior: "smooth" });
};
